import { render, staticRenderFns } from "./ReceiveOperation.vue?vue&type=template&id=581d071b"
import script from "./ReceiveOperation.vue?vue&type=script&lang=js"
export * from "./ReceiveOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports